import { Storybook } from "@tento-ui/ui/storybook";
import { TurnPlan } from "./plan";

export class TurnPlanStoryBook extends Storybook.Default {
  title(): string {
    return "Turn · plan";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Mid-plan",
        render: () =>
          TurnPlan.makeWith({
            steps: [
              {
                step: "Verify the navigator design against runtime seams",
                status: "done",
              },
              {
                step: "Implement the pane anchor/tail mechanism",
                status: "running",
              },
              {
                step: "Land the messages header as attach-scene policy",
                status: "pending",
              },
              { step: "Run focused integration checks", status: "pending" },
            ],
          }),
      },
      {
        title: "Single step",
        render: () =>
          TurnPlan.makeWith({
            steps: [{ step: "Rebuild and smoke the preview", status: "done" }],
          }),
      },
    ];
  }
}
